import React, { ReactNode, useState } from 'react';
import { Accordion, Typography } from 'fronton-react';
import { faqItemStyles } from './styles';

type FaqItemProps = {
	title: string;
	children: ReactNode;
};

export const FaqItem = ({ title, children }: FaqItemProps) => {
	const [isClose, setIsClose] = useState(true);
	return (
		<Accordion
			className={faqItemStyles}
			size="m"
			title={
				<Typography size={isClose ? 'body_long' : 'body_accent'} variant="m">
					{title}
				</Typography>
			}
			onClick={setIsClose}
		>
			{children}
		</Accordion>
	);
};
